import { useEffect } from 'react';

export const useInterface = () => {
    useEffect(() => {
        const onMessage = (event) => {
            const { type } = event.data;

            if (type === 'registered') {
                const { id } = event.data;
                const height = document.body.offsetHeight;

                const changeHeight = (height) => {
                    event.source.postMessage({ type: 'changeHeight', id, height }, event.origin);
                };

                changeHeight(height);

                window.addEventListener('resize', () => {
                    const height = document.body.offsetHeight;

                    changeHeight(height);
                });
            }
        };

        window.addEventListener('message', onMessage);

        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, []);
};
